import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileTabBar } from './MobileTabBar';
import { useAuthStore } from '@/stores/authStore';

export function MainLayout() {
  const refresh = useAuthStore((s) => s.refresh);
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    if (token) refresh();
  }, [token, refresh]);

  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <Outlet />
      </main>
      <div className="hidden lg:block">
        <Footer />
      </div>
      <MobileTabBar />
    </div>
  );
}
